import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import Popovers from '../../../components/bootstrap/Popovers';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Icon from '../../../components/icon/Icon';
import ThemeContext from '../../../contexts/themeContext';
import UserImageWebp from '../../../assets/img/wanna/wanna4.webp';
import { userAtom } from '../../../_atoms/user';
import { HeaderRight } from '../../../layout/Header/Header';
import { useTranslation } from 'react-i18next';
import LANG, { getLangWithKey } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../../components/bootstrap/Dropdown';

const CommonHeaderRight = () => {
    const { darkModeStatus, setDarkModeStatus } = useDarkMode();
    const { fullScreenStatus, setFullScreenStatus, setRightMenuStatus } = useContext(ThemeContext);
    const [user] = useAtom(userAtom)
    const styledBtn = {
        color: darkModeStatus ? 'dark' : 'light',
        hoverShadow: 'default',
        isLight: !darkModeStatus,
        size: 'lg',
    };

    const { i18n } = useTranslation();
    const { t } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng).then();
        showNotification(
            <span className='d-flex align-items-center'>
                <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
                <span>{t("common.langTitle", {lang : getLangWithKey(lng)?.text})}</span>
            </span>,
            t("common.langText"),
        );
    };

    useEffect(() => {
        i18n.changeLanguage("tr")
    },[])

    const navigate = useNavigate();

    return (
        <HeaderRight>
            <div className='row g-3 align-items-center'>
                <div className='col-auto'>
                    <span className='user-name' style={{ marginRight: 10 }}>
                        {user.firstname} {user.familyname}
                    </span>
                    <Popovers trigger='hover' desc="Profil">
                        <Button
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...styledBtn}
                            onClick={() => {
                                setRightMenuStatus(false)
                                navigate("/profil")
                            }
                            }
                            className='btn-only-icon'
                            data-tour='dark-mode'
                            aria-label='Toggle dark mode'>
                            <img
                                srcSet={user && user.avatar ? user.avatar : UserImageWebp}
                                src={user && user.avatar ? user.avatar : UserImageWebp}
                                alt='Avatar'
                                width="100%"
                                height="100%"
                                style={{ borderRadius: "50%" }}
                            />
                        </Button>
                    </Popovers>
                </div>
                {/* Lang Selector */}
                {/* <div className='col-auto'>
                    <Dropdown>
                        <DropdownToggle hasIcon={false}>
                            {typeof getLangWithKey(i18n.language)?.icon ===
                                'undefined' ? (
                                <Button
                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                    {...styledBtn}
                                    className='btn-only-icon'
                                    aria-label='Change language'
                                    data-tour='lang-selector'>
                                    <Spinner isSmall inButton='onlyIcon' isGrow />
                                </Button>
                            ) : (
                                <Button
                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                    {...styledBtn}
                                    icon={
                                        getLangWithKey(i18n.language)?.icon
                                    }
                                    aria-label='Change language'
                                    data-tour='lang-selector'
                                />
                            )}
                        </DropdownToggle>
                        <DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
                            {Object.keys(LANG).map((i) => (
                                <DropdownItem key={LANG[i].lng}>
                                    <Button
                                        icon={LANG[i].icon}
                                        onClick={() => changeLanguage(LANG[i].lng)}>
                                        {LANG[i].text}
                                    </Button>
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                </div> */}
                {/*	Full Screen */}
                <div className='col-auto'>
                    <Popovers trigger='hover' desc='Tam Ekran'>
                        <Button
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...styledBtn}
                            icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
                            onClick={() => setFullScreenStatus(!fullScreenStatus)}
                            aria-label='Toggle fullscreen'
                        />
                    </Popovers>
                </div>
                {/* Dark Mode */}
                <div className='col-auto'>
                    <Popovers trigger='hover' desc='Dark / Light Mod'>
                        <Button
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...styledBtn}
                            onClick={() => setDarkModeStatus(!darkModeStatus)}
                            className='btn-only-icon'
                            data-tour='dark-mode'
                            aria-label='Toggle dark mode'>
                            <Icon
                                icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
                                color={darkModeStatus ? 'info' : 'warning'}
                                className='btn-icon'
                            />
                        </Button>
                    </Popovers>
                </div>
            </div>
        </HeaderRight>
    )
}

export default CommonHeaderRight